import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ChargeCategoryFragment } from 'src/api/api.generated'
import { faArrowRotateLeft } from '@fortawesome/free-solid-svg-icons'
import { useMemo } from 'react'
import { Tooltip } from '@vapor/material'
import { useTranslation } from 'react-i18next'

type RRBulkEditChargeCategoryGridCellProps = {
  initialValue: string | undefined
  value: string | undefined
  onChange: (value: string | undefined) => void
  chargeCategories: ChargeCategoryFragment[]
  disabled?: boolean
}

export default function RRBulkEditChargeCategoryGridCell(props: RRBulkEditChargeCategoryGridCellProps) {
  const { initialValue, value, onChange, chargeCategories, disabled } = props
  const valueIsChanged = useMemo(() => initialValue !== value, [initialValue, value])
  const { t } = useTranslation()

  return (
    <div style={{ display: 'flex', flexDirection: 'row', gap: '2px', justifyContent: 'center', alignItems: 'center' }}>
      {valueIsChanged && (
        <Tooltip title={t('commons.reset.tooltip')}>
          <span>
            <FontAwesomeIcon icon={faArrowRotateLeft} color="red" style={{ cursor: 'pointer' }} onClick={() => onChange(initialValue)} />
          </span>
        </Tooltip>
      )}
      <select style={{ width: '115px' }} value={value} onChange={(event) => onChange(event.target.value)} disabled={disabled}>
        {chargeCategories.map((cc) => {
          return (
            <option key={cc.id} value={cc.id}>
              {cc.name}
            </option>
          )
        })}
      </select>
    </div>
  )
}
